/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Cool_Heron_WadeInputs */

const en_mild_cool_heron_wade = /** @type {(inputs: Mild_Cool_Heron_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neutrals`)
};

const de_mild_cool_heron_wade = /** @type {(inputs: Mild_Cool_Heron_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neutrale`)
};

/**
* | output |
* | --- |
* | "Neutrals" |
*
* @param {Mild_Cool_Heron_WadeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mild_cool_heron_wade = /** @type {((inputs?: Mild_Cool_Heron_WadeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Cool_Heron_WadeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mild_cool_heron_wade(inputs)
	return de_mild_cool_heron_wade(inputs)
});